import React from "react";
import PropTypes from 'prop-types';
import renderLoader from "../../base/Loader";
import register, {
	assignCandidateToPosition, checkCandidateRecruProcessExists,
	sendMailNotification
} from "../../../services/PostService";
import {registerToGlobalPool} from "../../../services/UpdateService";
import RegisterForm from "./RegisterForm";
import {getGateCheckboxes} from "../../../services/DataGetter";
import RegisterStepInlineWarning from './RegisterStepInlineWarning';
import debounce from 'lodash.debounce';

export default class RegisterStep extends React.PureComponent
{
    static propTypes = {
        language: PropTypes.string.isRequired,
        positionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        nextStep: PropTypes.func.isRequired,
        setBannerData: PropTypes.func.isRequired,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
        sex: PropTypes.number,
        showModal: PropTypes.func.isRequired,
        customerData: PropTypes.objectOf(Promise).isRequired,
        customerName: PropTypes.string.isRequired,
        renderError: PropTypes.func.isRequired,
		requireCv: PropTypes.bool,
        prescreeningOnly: PropTypes.bool,
		uploadToMongo: PropTypes.func
    };

    static defaultProps = {
        positionId: null,
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        sex: null
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            firstName : this.props.firstName,
            lastName : this.props.lastName,
            email : this.props.email,
            displayedNotification: false,
            checkboxes : this.getCheckboxes(),
			inlineWarning: null,
			skipCv: false
        };
        this.checkDuplicateCandidate();
        this.loadData();
    }

    getCheckboxes = () => {
        return getGateCheckboxes(this.props.customerName)
            .then(response => response.json())
            .then(json => json.result)
            .catch( exception => {
                return setTimeout(this.getCheckboxes, 5000);
            });
    };

    loadData = () => {
        this.props.customerData
            .then((customerData) => {
                this.setState({loading: false, personalNumber: customerData.result['personalNumberSettings'], skipCv: customerData.result.gateSettings['skipCv']});
            });
    };

    register = (data, formResponse) => {
        this.setState({loading: true});
        let candidateId = sessionStorage.getItem('userId-' + this.props.customerName);

		if (formResponse && formResponse.formResponseParts) {
			formResponse.formResponseParts = formResponse.formResponseParts.filter((result) => {
				return result.hasOwnProperty('value') || (result.hasOwnProperty('formPartOptions') && result.formPartOptions.length > 0)
			})
		}

        if (!candidateId) {
            if (sessionStorage.getItem('cv-file-mongoid')) {
                data['mongoId'] = sessionStorage.getItem('cv-file-mongoid');
                data['fileName'] = sessionStorage.getItem('cv-file-name');
                data['fileSize'] = sessionStorage.getItem('cv-file-size');
                sessionStorage.removeItem('cv-file-mongoid');
                sessionStorage.removeItem('cv-file-name');
                sessionStorage.removeItem('cv-file-size');
            }
            data['acceptedDocumentIds'] = JSON.parse(sessionStorage.getItem('checkboxes-'+this.props.customerName));
            data['acceptedDocumentDates'] = JSON.parse(sessionStorage.getItem('checkbox-dates-' + this.props.customerName));
            data['questionnaire'] = formResponse;
            register(data)
                .then( response => response.json())
                .then( json => {
                    if(json['success'] === true) {
						sendMailNotification(this.props.language, this.props.customerName, json['candidateId'], data['email'], json['jobApplicationId'], this.props.positionId);
						sessionStorage.removeItem('prescreening');
                        sessionStorage.setItem('apiKey-'+this.props.customerName, json['apiKey']);
                        sessionStorage.setItem('userName-' +this.props.customerName, data['firstName']+' '+data['lastName']);
                        sessionStorage.setItem('email-' +this.props.customerName, data['email']);
                        sessionStorage.setItem('phone-' +this.props.customerName, data['phone']);
                        sessionStorage.setItem('userId-' + this.props.customerName, json['candidateId']);
                        sessionStorage.setItem('assignedToPositions-' + this.props.customerName, JSON.stringify(this.props.positionId ? [this.props.positionId] : []));
                        sessionStorage.setItem('registeredToGlobalPool-' + this.props.customerName, this.props.positionId ? 0 : 1);
                        this.props.setBannerData(data['firstName']+' '+data['lastName']);
                        this.props.nextStep();
                    } else {
                        this.setState({loading: false})
                        this.props.renderError(json.reason)
                    }
                })
                .catch( error => {
                    this.setState({loading: false});
                    this.props.showModal(window.Translator.getSlug('Error', this.props.language), error.toString());
                });
        } else {
            if (this.props.positionId) {
                assignCandidateToPosition({
                    "candidateId": candidateId,
                    "positionId": this.props.positionId,
                    "customerName": this.props.customerName,
					"questionnaire" : formResponse,
                }, null)
                    .then(response => response.json())
                    .then(json => {
                        if (json.success && json.candidateRecruProcessId) {
							sendMailNotification(this.props.language, this.props.customerName, candidateId, sessionStorage.getItem('email-' +this.props.customerName), json['jobApplicationId'], this.props.positionId);
							sessionStorage.removeItem('prescreening');
							sessionStorage.setItem('assignedToPositions-' + this.props.customerName, JSON.stringify( (JSON.parse(sessionStorage.getItem('assignedToPositions-'+ this.props.customerName)) || []).concat(this.props.positionId)));
                            this.props.nextStep();
                        } else if (json.hasOwnProperty('alreadyExists') && json.alreadyExists){
							sessionStorage.removeItem('prescreening');
							this.props.showModal(window.Translator.getSlug('Warning', this.props.language), window.Translator.getSlug('AlreadyApplied', this.props.language));
                            this.setState({loading:false});
                        } else {
                            this.setState({loading: false})
                            this.props.renderError(json.reason)
                        }
                    }).catch( error => {
                    this.setState({loading: false});
                    this.props.showModal(window.Translator.getSlug('Error', this.props.language), error.toString());
                })
            } else {
                registerToGlobalPool(candidateId, formResponse, this.props.customerName)
                    .then( response => {
						const json = response.json();
						if( response.status === 200 ) {
							sendMailNotification(this.props.language, this.props.customerName, candidateId, sessionStorage.getItem('email-' +this.props.customerName), json['jobApplicationId']);
							sessionStorage.removeItem('prescreening');
							sessionStorage.setItem('registeredToGlobalPool-'+this.props.customerName, '1');
                            this.props.nextStep();
                        } else {
                            this.setState({loading: false});
                            this.props.showModal(window.Translator.getSlug('Error', this.props.language), json.hasOwnProperty('reason') ? json.reason : '');
                        }
                    });
            }
        }
    };

    checkDuplicateCandidate = () => {
		if (this.state['firstName'] && this.state['lastName'] && this.state['email']) {
			checkCandidateRecruProcessExists(this.state['firstName'], this.state['lastName'], this.state['email'], this.props.positionId)
				.then(data => {
					this.setState({ inlineWarning: data && data.length > 0 && data[0] === true ? 'YouAlreadyAppliedForThisPositionWouldYouLikeToContinue' : null })
				})
		}
	}

    checkCandidateExists = debounce((name, value) => {
			if (name && value && !this.state['displayedNotification'] && this.props.positionId) {
				let stateObj = {};
				stateObj[name] = value;
				this.setState(stateObj, () => {
					this.checkDuplicateCandidate();
				});
			}
		}
        , 500);


    render() {
        if (this.state['loading']) {
            return renderLoader('d-block text-center display-3');
        }
        return (
            <div className={"section-padding-30"}>
				{this.state.inlineWarning && <RegisterStepInlineWarning warning={window.Translator.getSlug(this.state.inlineWarning, this.props.language)}/>}
                <RegisterForm
                    language={this.props.language}
                    customerName={this.props.customerName}
                    positionId={this.props.positionId}
                    prescreeningOnly={this.props.prescreeningOnly}
                    registerFunction={this.register}
                    sex={this.props.sex}
                    checkCandidateExists={this.checkCandidateExists}
                    firstName={this.props.firstName}
                    lastName={this.props.lastName}
                    email = {this.props.email}
                    phone = {this.props.phone}
                    personalNumber = {this.state['personalNumber']}
                    checkboxes = {this.state['checkboxes']}
                    formUrl = {this.props.formUrl}
					uploadToMongo={this.props.uploadToMongo}
					skipCv={this.state['skipCv']}
					requireCv={this.props.requireCv}
                />
            </div>
        );
    }
}
